export const FETCH_ACTIVITY_LIST_REQUEST = "FETCH_ACTIVITY_LIST_REQUEST";
export const FETCH_ACTIVITY_LIST_SUCCESS = "FETCH_ACTIVITY_LIST_SUCCESS";
export const FETCH_ACTIVITY_LIST_FAILURE = "FETCH_ACTIVITY_LIST_FAILURE";

export const DOWNLOAD_ACTIVITY_FILE_REQUEST = "DOWNLOAD_ACTIVITY_FILE_REQUEST";
export const DOWNLOAD_ACTIVITY_FILE_SUCCESS = "DOWNLOAD_ACTIVITY_FILE_SUCCESS";
export const DOWNLOAD_ACTIVITY_FILE_FAILURE = "DOWNLOAD_ACTIVITY_FILE_FAILURE";

export const GET_ACTIVITY_DETAILS_BY_ID_REQUEST = "GET_ACTIVITY_DETAILS_BY_ID_REQUEST";
export const GET_ACTIVITY_DETAILS_BY_ID_SUCCESS = "GET_ACTIVITY_DETAILS_BY_ID_SUCCESS";
export const GET_ACTIVITY_DETAILS_BY_ID_FAILURE = "GET_ACTIVITY_DETAILS_BY_ID_FAILURE";
